import { useState, useEffect } from "react";
import { KTCard, KTCardBody, KTIcon } from "../../../_metronic/helpers";
import axios from "axios";
import { GiftVoucherHeader } from "./header/GiftVoucherHeader";
import { toast } from "react-toastify";
import { CreateVoucherModal } from "./CreateVoucher/CreateVoucherModal";
import { VoucherDetailsModal } from "./VoucherDetailsModal/VoucherDetailsModal";
import moment from "moment";
import { useAuth } from "../auth";
import dayjs from "dayjs";
import { Pagination } from "../../../components/Pagination";
import { formatPrice } from "../../../_metronic/helpers/utils";
import { UsersListLoading as Loading } from "../apps/user-management/users-list/components/loading/UsersListLoading";
import FileDownload from "js-file-download";

const GiftVouchers = () => {
  const { currentUser, haveAccess } = useAuth();
  const [isLoading, setLoading] = useState(false);
  const [vouchers, setVouchers] = useState([]);
  const [voucherDetails, setVoucherDetails] = useState(null);
  const [openVoucherDetailsModal, setOpenVoucherDetailsModal] = useState(false);
  const [openCreateVoucherModal, setOpenCreateVoucherModal] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [total, setTotal] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [displayType, setDisplayType] = useState('list');

  const fetchVouchers = () => {
    axios
      .get(`${process.env.REACT_APP_API_V3_URL}/wallets/redemption-codes`, {
        params: {
          page_size: pageSize,
          page,
          ...(startDate ? { start_date: dayjs(startDate).format('YYYY-MM-DD') } : ''),
          ...(endDate ? { end_date: dayjs(endDate).format('YYYY-MM-DD') } : '')
        },
      })
      .then((response) => {
        setVouchers(response?.data?.data);
        setTotal(response?.data?.total);
      }).catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
      });
  };

  const getVoucherDetials = async (id, download = false) => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_V3_URL}/wallets/redemption-codes/${id}${download ? '?get_file=true' : ''}`, {
      responseType: download ? 'text/csv' : 'json'
    })
      .then((response) => {
        if (download) {
          FileDownload(response?.data, 'voucher.csv');
          toast.success('File downloaded successfully');
        } else {
          setVoucherDetails(response?.data);
          setOpenVoucherDetailsModal(true);
        }
        setLoading(false);
      }).catch((err) => {
        if (err && err.response && err.response?.data && err.response?.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Technical Error, Please Try Again");
        }
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchVouchers();
    setVoucherDetails(null);
  }, [page, pageSize, startDate, endDate]);

  useEffect(() => {
    if (startDate || endDate) {
      setPage(1);
    }
    if (pageSize !== 30) {
      setPage(1);
    }
  }, [pageSize, startDate, endDate]);


  return (
    <KTCard className="position-relative">
      <GiftVoucherHeader setOpenCreateVoucherModal={setOpenCreateVoucherModal} currentUser={currentUser}
        haveAccess={haveAccess} setStartDate={setStartDate} setEndDate={setEndDate}
        startDate={startDate} endDate={endDate} displayType={displayType}
        setDisplayType={setDisplayType}
      />
      {(haveAccess(currentUser, 'redemption_codes_view')) ?
        <KTCardBody className="pt-0">
          <div className="row g-4">
            {vouchers && vouchers.length > 0 ?
              <div className="mb-10" style={{ display: 'grid', gap: '10px', gridTemplateColumns: `${displayType === 'grid' ? 'repeat(3, 1fr)' : '1fr'}` }}>
                <>
                  {displayType === 'list'
                    ? <List vouchers={vouchers} getVoucherDetials={getVoucherDetials} isLoading={isLoading} />
                    : <Grid vouchers={vouchers} getVoucherDetials={getVoucherDetials} isLoading={isLoading} />}
                </>
              </div>
              :
              <h4 className="text-center">No Gift Vouchers Available</h4>
            }
            <Pagination
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
              total={total}
              pageSizeOptions={[30, 60, 100, 200]}
            />
          </div>
        </KTCardBody>
        :
        <div className='d-flex text-center w-100 align-content-center justify-content-center' style={{ height: '70vh', alignItems: 'center', fontSize: '42px', color: '#ffa049', background: 'rgba(0,0,0,0.1)' }}>
          You do not have permission to view
        </div>
      }
      {openCreateVoucherModal && (
        <CreateVoucherModal
          setOpenCreateVoucherModal={setOpenCreateVoucherModal}
          fetchVouchers={fetchVouchers}
        />
      )}
      {openVoucherDetailsModal && (
        <VoucherDetailsModal
          setOpenVoucherDetailsModal={setOpenVoucherDetailsModal}
          voucherDetails={voucherDetails}
          setVoucherDetails={setVoucherDetails}
          getVoucherDetials={getVoucherDetials}
          isLoading={isLoading}
        />
      )}
      {isLoading && <Loading onTop={true} />}
    </KTCard>
  );
};

export default GiftVouchers;

export const Grid = ({ vouchers, getVoucherDetials, isLoading }) => {
  return vouchers?.map((item, index) => {
    return (
      <div
        className="form-check form-check-custom form-check-solid d-flex justify-content-between align-items-center flex-wrap p-5 rounded-2"
        key={index}
        style={{
          background: ((item.usage === item.total) || moment(item.end_date).isSameOrBefore(moment())) ? '#f9f9f9' : "#e3feee9e",
        }}
      >
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Amount</label>
          <h5 className="fw-bolder text-main">{formatPrice(item.amount)}</h5>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Status</label>
          <h5 className="fw-bolder" style={{ color: ((item.usage === item.total) || moment(item.end_date).isSameOrBefore(moment())) ? '#ed2626' : '#2ecc71'}}>
          {(item.usage === item.total) ? "Redeemed" : moment(item.end_date).isSameOrBefore(moment()) ? "Expired" : "Active"}
          </h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Start Date</label>
          <h5 className="fw-bolder text-main">{moment(item.start_date).format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Expiration Date</label>
          <h5 className="fw-bolder text-main">{moment(item.end_date).format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Vouchers Used</label>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}>
            <h5 className="fw-bolder text-main">{item.usage || 0}</h5>
          </div>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Total Vouchers</label>
          <div>
            <h5 className="fw-bolder text-main">{item.total || 1}</h5>
          </div>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Requested By</label>
          <h5 className="fw-bolder text-main">{item.requested_by || "-"}</h5>
        </div>
        <div className="fv-row w-50 text-end">
          <label className="fw-bold fs-6 mb-2">Created By</label>
          <div>
            <h5 className="fw-bolder text-main">{item.created_by || "-"}</h5>
          </div>
        </div>
        <div className="fv-row w-100 text-end">
          <label className="fw-bold fs-6 mb-2"></label>
          <button className="btn btn-sm btn-success"
            disabled={isLoading}
            onClick={() => getVoucherDetials(item.batch_id)}>
            View Vouchers
          </button>
        </div>
      </div>
    )
  })
}

export const List = ({ vouchers, getVoucherDetials, isLoading }) => {

  const headers = [
    { title: 'Start Date', width: '120px' },
    { title: 'Expiration Date', width: '120px' },
    { title: 'Amount', width: '100px' },
    { title: 'Status', width: '120px' },
    { title: 'Vouchers Used', width: '130px' },
    { title: 'Total Vouchers', width: '130px' },
    { title: 'View Vouchers', width: '130px', },
    { title: 'Created By', width: '140px' },
    { title: 'Requested By', width: '130px', className: 'text-end px-2' },
  ]

  return (
    <div className='table-responsive'>
      <table
        id='kt_table_users'
        className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            {headers.map(column => (
              <th
                key={column.title}
                className={column.className}
                style={{ minWidth: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='text-gray-600 fw-bold'>
          {vouchers?.length > 0 && (
            vouchers.map(row => (
              <tr key={row.arrear_id}>
                <td style={{ minWidth: headers[0].width }}>{moment(row.start_date).format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[1].width }}>{moment(row.end_date).format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[2].width }}>{formatPrice(row.amount)}</td>
                <td style={{ minWidth: headers[3].width, color: ((row.usage === row.total) || moment(row.end_date).isSameOrBefore(moment())) ? '#ed2626' : '#2ecc71'}}>
                  {(row.usage === row.total) ? 'Redeemed' : moment(row.end_date).isSameOrBefore(moment()) ? "Expired" : "Active"}
                </td>
                <td style={{ minWidth: headers[4].width }}>{row.usage || 0}</td>
                <td style={{ minWidth: headers[5].width }}>{row.total || 1}</td>
                <td style={{ minWidth: headers[6].width }}><button className="btn btn-sm btn-transparent" disabled={isLoading} onClick={() => getVoucherDetials(row.batch_id)}><KTIcon iconName="eye" className='fs-2 m-0 text-main' />View</button></td>
                <td style={{ minWidth: headers[7].width }}>{row.created_by || "-"}</td>
                <td style={{ minWidth: headers[8].width }} className={headers[8].className}>{row.requested_by || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}